import { render, staticRenderFns } from "./MovieWorldCup.vue?vue&type=template&id=565ea2d8&"
import script from "./MovieWorldCup.vue?vue&type=script&lang=js&"
export * from "./MovieWorldCup.vue?vue&type=script&lang=js&"
import style0 from "./MovieWorldCup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
